//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { localPaginationMixin } from '@/mixins/local_pagination';
export default {
  name: 'DashboardDictionaryDatatable',
  props: {
    item: {
      type: Object,
      required: false,
      default: null
    }
  },
  mixins: [localPaginationMixin],
  data: function data() {
    return {
      valid: false,
      key_table: 0,
      mostrarFormulario: false,
      items: this.item.dashboard,
      headers: [{
        text: 'Página',
        value: 'Pagina'
      }, {
        text: 'Ventana',
        value: 'Ventana'
      }, {
        text: 'Gráfico',
        value: 'Grafico'
      }, {
        text: 'Tipo Gráfico',
        value: 'TipoGrafico'
      }, {
        text: 'Descripción',
        value: 'Descripcion'
      }, {
        text: 'Fórmula',
        value: 'Formula'
      }, {
        text: 'Fuente',
        value: 'Fuente'
      }, {
        text: 'Automatizada',
        value: 'Automatizada'
      }, {
        text: 'Proyecto',
        value: 'Proyecto'
      }, {
        text: 'Dataset',
        value: 'Dataset'
      }, {
        text: 'Tabla',
        value: 'Tabla'
      }]
    };
  },
  created: function created() {},
  methods: {
    onAdd: function onAdd() {
      this.mostrarFormularioe = true;
    }
  },
  computed: {}
};